module.exports = __webpack_public_path__ + "static/media/attendance.0b87fac8.svg";